import React, { useState } from "react";
import NotFoundHeader from "./components/NotFoundHeader";
import NotFoundNavbar from "./components/NotFoundNavbar";
import ReactHelmet from "./components/ReactHelmet";
import languages from "./lang/languages";

export default function PageNotFound() {
  const [language] = useState(languages);

  return (
    <main className="main page-not-found">
      <ReactHelmet titleName="404" description="Böyle bir sayfa yok. Doğru teknolojiye ulaşmak için ana sayfaya geri dönebilirsin." />
      <NotFoundNavbar />
      <NotFoundHeader language={language} />
    </main>
  );
}
